export enum BioKinds {
  NONE = '0',
  EUNONEU = '1',
  EU = '2',
  NONEU = '3'
}
